export const INITIAL_STATE_TIMETRACKER = '00:00:00';
export const REDIRECT_PAGE_URL = '/auth/callback';
export const LAST_AUTH_TIME = 'lastAuthTime';
